(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-wholesale"] && !Shopify.designMode) return;
  try {
    
  class WholesaleApplicationEmbedMonitor extends HTMLElement {
    connectedCallback() {
      this.fallback = this.querySelector('[ref="fallback"]');
      this.observer = new MutationObserver(() => this.updateState());
      this.observer.observe(this, { childList: true, subtree: true });
      this.timeout = window.setTimeout(() => this.updateState(true), 4000);
      this.updateState();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
    }

    updateState(forceFallback = false) {
      const hasMountedEmbed = Array.from(this.children).some((node) => {
        return (
          node instanceof HTMLElement &&
          node !== this.fallback &&
          node.tagName !== 'SCRIPT'
        );
      });

      if (hasMountedEmbed) {
        this.fallback?.classList.add('hidden');
        return;
      }

      if (forceFallback) {
        this.fallback?.classList.remove('hidden');
        this.fallback?.focus();
      }
    }
  }

  if (!customElements.get('wholesale-application-embed-monitor')) {
    customElements.define('wholesale-application-embed-monitor', WholesaleApplicationEmbedMonitor);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
